import { api } from '@/utils/api';

/**
 * Получает платежи заказа.
 *
 * Ручка появилась после того, как бэк убрал `payments` из сущности заказа
 * (06.08.2026). Форма ответа в Swagger не описана (`responses: default`),
 * поэтому возвращается `unknown` и разбирается `parseOrderPayments`.
 *
 * @param orderUuid - UUID заказа
 * @returns сырой ответ бэка
 */
export const fetchOrderPayments = async (
  orderUuid: string
): Promise<unknown> => {
  const { data } = await api.get<unknown>(`/admin/payments/${orderUuid}`);
  return data;
};
